export function AMINTOMNR(outletName, outletId, companyCode) {
        if (outletName != "" && outletId != "" && companyCode != "")
        return {
            type: "AMINTOMNR",
            outletName: outletName,
            outletId: outletId,
            companyCode: companyCode
        }
}
export function RESET() {
    return {
        type: "RESET",
    }
}
